import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
// import {
//     AvailabilityDto,
//     AvailabilityMessageType,
//     ProductSettingsModel,
//     WarehouseDto,
// } from "@insite/client-framework/Types/ApiModels"; // Poolcorp Custom Code
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Icon, { IconWrapper } from "@insite/mobius/Icon"; // Poolcorp Custom Code
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Poolcorp Custom Code */
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductSettingsModel,
    WarehouseDto,
    WarehouseModel,
} from "@insite/client-framework/Types/ApiModels";
import Clickable from "@insite/mobius/Clickable";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Info from "@insite/mobius/Icons/Info";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import StoreAvailabilityTable from "@store/Components/Store/StoreAvailabilityTable";
import { availabilityAnchorLink } from "@store/Components/Store/StoreProductDetailsView/StoreProductDetailsView";
import StoreProductIsStockedMessage from "@store/Components/Store/StoreProductIsStockedMessage";
import { getStoreSession } from "@store/Store/Context/ContextSelectors";
import { scalableIconStyles } from "@store/theme/common/mixins";
import { loadingDotsAnimation } from "@store/theme/common/mixins/typography";
import { TYPOGRAPHY } from "@store/theme/design";
import getBooleanProperty from "@store/utilities/getBooleanProperty";
/* Poolcorp Custom Code */

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    // Poolcorp Custom Code
    isStocked?: boolean;
    selectedWarehouse?: WarehouseDto | WarehouseModel | null;
    isCondensed?: boolean;
    isAvailableInWarehouseSequence?: boolean;
    qtyAvailable?: number;
    qtyOrdered?: number;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    /* Poolcorp Custom Code */
    const session = getStoreSession(state);

    return {
        productSettings: getSettingsCollection(state).productSettings,
        showInventory: state.context.showInventory,
        currentWarehouseName:
            props.selectedWarehouse?.name ||
            (session.fulfillmentMethod === FulfillmentMethod.PickUp
                ? session.pickUpWarehouse?.name
                : session.warehouse.name),
        currentWarehouseDescription:
            props.selectedWarehouse?.description ||
            (session.fulfillmentMethod === FulfillmentMethod.PickUp
                ? session.pickUpWarehouse?.description
                : session.warehouse.description),
    };
    /* Poolcorp Custom Code */
};

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasProductContext & HasCartLineContext; // Poolcorp Custom Code

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    // Poolcorp Custom Code
    availabilityByWarehouseQuantityTableCell?: DataTableCellBaseProps;
    availabilityByWarehouseStockedTableCell?: DataTableCellBaseProps;
    availabilityWrapper?: InjectableCss;
    availabilityIconStyles?: IconProps;
    availabilityByWarehouseGlobalTableRow?: DataTableRowProps;
    availabilityByWarehouseTableRowActive?: DataTableRowProps;
    availabilityLinkStyles?: LinkPresentationProps;
    inventoryWarehouse?: InjectableCss;
    inventoryStocking?: InjectableCss;
}

/* Poolcorp Custom Code */
const getTableCellProps = (textAlign?: "right" | "center") => ({
    css: css`
        padding: 0.75em 1em;
        color: inherit;
        background-color: inherit;
        ${textAlign ? `text-align: ${textAlign};` : null}
    `,
});
/* Poolcorp Custom Code */

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
        `,
    },
    availabilityWrapper: {
        css: css`
            margin-bottom: .5em;
        `,
    },
    messageGridItem: { width: 12 },
    availabilityByWarehouseLinkGridItem: { width: 12 },
    availabilityByWarehouseModal: {
        size: 440,
        cssOverrides: {
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                padding: 10px 10px 10px 20px;
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    messageText: {
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.bold,
        lineHeight: TYPOGRAPHY.lineHeight.small,
        css: css`
            margin-right: 0.25em;
            ${wrapInContainerStyles}
        `,
    },
    realTimeText: {
        css: css`
            ${loadingDotsAnimation()}
        `,
    },
    errorText: {
        css: css`
            width: 100%;
            word-wrap: break-word;
        `,
    },
    inventoryWarehouse: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    inventoryMessage: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    inventoryStocking: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    availabilityIconStyles: {
        src: Info,
        css: css`
            ${scalableIconStyles()}
            top: 0;
            font-size: 1.1em;
        `,
    },
    availabilityByWarehouseTable: {
        cssOverrides: {
            table: css`
                ${({ theme }) => theme?.dataTable?.defaultProps?.cssOverrides?.table}
                border: 0;
            `,
        },
    },
    availabilityByWarehouseTableCell: getTableCellProps(),
    availabilityByWarehouseQuantityTableCell: getTableCellProps(),
    availabilityByWarehouseStockedTableCell: getTableCellProps("center"),
    availabilityByWarehouseTableHead: {
        css: css`
            background-color: ${getColor("common.border")};
            color: ${getColor("text")};
        `,
    },
    availabilityByWarehouseGlobalTableRow: {
        css: css`
            background-color: ${getColor("common.border")};
            color: ${getColor("text")};
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    availabilityByWarehouseTableRowActive: {
        css: css`
            /* Required to bypass even coloring */
            &:not(.important) {
                background-color: ${getColor("primary.light")};
                color: ${getColor("primary.contrast")};
                font-weight: ${TYPOGRAPHY.weight.bold};
            }
        `,
    },
    availabilityLinkStyles: {
        typographyProps: {
            css: css`
                display: flex;
                align-items: center;
            `,
        },
        css: css`
            text-decoration: none;
        `,
    },
};

/* Poolcorp Removed Code - InventoryMessage */

const getAvailabilityColor = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return "common";
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return "danger";
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return "warning";
    }

    return "success";
};

const getAvailabilityIcon = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return undefined;
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return X;
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return AlertTriangle;
    }

    return Check;
};

const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }

    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }

    return !!isProductDetailsPage;
};

const ProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    showInventory,
    extendedStyles,
    // Poolcorp Custom Code
    currentWarehouseName,
    currentWarehouseDescription,
    isStocked,
    productContext,
    cartLine,
    isCondensed = true,
    isAvailableInWarehouseSequence,
    qtyAvailable,
    qtyOrdered
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [qtyOnHand, setQtyOnHand] = useState(0); // Poolcorp Custom Code
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setWarehouses(result.warehouses);
                setQtyOnHand((result as any).qtyOnHand); // Poolcorp Custom Code
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };

    const availabilityColor = getAvailabilityColor(productSettings, availability); // Poolcorp Custom Code
    /* Poolcorp Removed - Icon */

    const [styles] = useState(() => mergeToNew(productAvailabilityStyles, extendedStyles));
    /* Poolcorp Removed - showInventory */
    /* Poolcorp Removed - failedToLoadInventory  */

    const scrollToAnchor = () => {
        window.location.href = `${window.location.pathname}#${availabilityAnchorLink}`;
    };

    const inventoryTextMessage = (color: string, message: string, hasLink = true, additionalMessage?: string) => { // Poolcorp Custom Code
        return (
            <>
                {/* Poolcorp Custom Code */}
                {!isCondensed && (
                    <StyledWrapper {...styles.inventoryWarehouse} /* Poolcorp Custom Code */>
                        <Typography  
                            {...styles.messageText} 
                            data-test-selector="availabilityMessage"
                        >
                            {currentWarehouseName} {currentWarehouseDescription}:
                        </Typography>
                    </StyledWrapper>
                )}
                {/* Poolcorp Custom Code */}
                <StyledWrapper {...styles.inventoryMessage} /* Poolcorp Custom Code */>
                    {/* Poolcorp Removed - Icon */}
                    {/* Poolcorp Moved Code - messageText Typography */}
                    {showLink(availability, trackInventory, productSettings, isProductDetailsPage) &&
                    hasLink &&
                    isProductDetailsPage ? (
                        <Link
                            onClick={scrollToAnchor}
                            title={translate("View Availability by Warehouse")}
                            {...styles.availabilityLinkStyles}
                        >
                            {/* Poolcorp Custom Code */}
                            <Typography  
                                color={color}
                                {...styles.messageText} 
                                data-test-selector="availabilityMessage"
                            >
                                {message}
                            </Typography>
                            {/* Poolcorp Custom Code */}
                            <Icon {...styles.availabilityIconStyles} color={color} />
                        </Link>
                    ) : (
                        <Clickable
                            onClick={viewAvailabilityByWarehouseClickHandler}
                            title={translate("View Availability by Warehouse")}
                        >
                            {/* Poolcorp Custom Code */}
                            <Typography  
                                color={color}
                                {...styles.messageText} 
                                data-test-selector="availabilityMessage"
                            >
                                {message}
                            </Typography>
                            {/* Poolcorp Custom Code */}
                            <Icon {...styles.availabilityIconStyles} color={color} />
                        </Clickable>
                    )}
                </StyledWrapper>
                {/* Poolcorp Custom Code */}
                {!isCondensed && (
                    <>
                        {additionalMessage?.length && (
                            <StyledWrapper {...styles.inventoryStocking}>
                                <Typography  
                                    {...styles.messageText} 
                                    data-test-selector="availabilityMessage"
                                >
                                    {additionalMessage}
                                </Typography>
                            </StyledWrapper>
                        )}
                        {!isProductDetailsPage && (
                            <StoreProductIsStockedMessage 
                                isStocked={isStocked}
                                qtyOnHand={qtyAvailable}
                                qtyOrdered={qtyOrdered}
                            />
                        )}
                    </>
                )}
                {/* Poolcorp Custom Code */}
            </>
        );
    };

    let inventoryTextComponent = <Typography {...styles.realTimeText} />;
    /* Poolcorp Custom Code */
    if (availability?.messageType === AvailabilityMessageType.Available && availability?.message?.length) {
        inventoryTextComponent = inventoryTextMessage(availabilityColor, availability.message, true, `(${qtyAvailable} ${translate("available")})`);
    } else if(availability?.messageType === AvailabilityMessageType.OutOfStock && availability?.message?.length) {
        if (isAvailableInWarehouseSequence) {
            inventoryTextComponent = inventoryTextMessage(availabilityColor, availability.message, true, translate("(Available at other locations)"));
        } else {
            inventoryTextComponent = inventoryTextMessage(availabilityColor, availability.message, true, translate("(Available for Backorder)"));
        }
    } else if (availability || failedToLoadInventory) {
        inventoryTextComponent = inventoryTextMessage("text.accent", translate("Inventory Not Available"), false);
    }

    if (isCondensed && availability?.messageType === AvailabilityMessageType.OutOfStock && isStocked) {
        inventoryTextComponent = inventoryTextMessage("info.contrast", translate("Backorder"));
    }
    
    const isHighDemandMode = getBooleanProperty((productContext?.product || cartLine)?.properties?.isHighDemandMode);
    /* Poolcorp Custom Code */

    return (
        <StyledWrapper {...styles.availabilityWrapper}>
            {inventoryTextComponent}
            {showLink(availability, trackInventory, productSettings, isProductDetailsPage) && (
                <Modal
                    {...styles.availabilityByWarehouseModal}
                    headline={translate("Branch Inventory")}
                    isOpen={modalIsOpen}
                    handleClose={modalCloseHandler}
                >
                    {isLoading && (
                        <StyledWrapper {...styles.centeringWrapper}>
                            <LoadingSpinner {...styles.spinner} />
                        </StyledWrapper>
                    )}

                    {/* Poolcorp Custom Code */}
                    {!isLoading && (
                        <StoreAvailabilityTable
                            warehouses={warehouses}
                            currentWarehouseName={currentWarehouseName}
                            qtyOnHand={qtyOnHand}
                            isHighDemandMode={isHighDemandMode}
                        />
                    )}
                    {/* Poolcorp Custom Code */}
                </Modal>
            )}
        </StyledWrapper>
    );
    /* Poolcorp Custom Code */
};

export default connect(mapStateToProps, mapDispatchToProps)(withCartLine(withProductContext(ProductAvailability))); // Poolcorp Custom Code
